import { Prose } from '../../components/prose'

export interface EvaluationSummaryProps {
  summary: string
}

export function EvaluationSummary({ summary }: EvaluationSummaryProps) {
  return (
    <div className="mt-4 rounded-xl border border-border bg-card/30 px-6 py-4">
      <p className="mb-2 text-[10px] font-semibold uppercase tracking-widest text-muted-foreground/80">
        Executive Summary
      </p>
      <Prose className="text-sm leading-relaxed text-muted-foreground">{summary}</Prose>
    </div>
  )
}
